import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Drawer, Stack, Button, Autocomplete } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { AmountFormat, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';


const RtSessionTatReport = () => {
    const datelist = {
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
        selectVendor: null
    }
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [TatDataList, setTatDataList] = useState([]);
    const [avgTAt, setavgTat] = useState("");
    const [sessionCount, setSessionCount] = useState("");
    const [isloader, setisloader] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [filterData, setfilterData] = useState(datelist);

    useEffect(() => {
        getTatDataList()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }


    const getTatDataList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.RT_TAT_REPORT + `?from_date=${filterData?.fromDate}&to_date=${filterData?.toDate}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setTatDataList(response.data.data || [])
                        setSessionCount(response.data.total_sessions || 0)
                        setavgTat(response.data.average_tat_time || "")
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getTatDataListPrint = () => {
        try {
            RestAPIService.getAllPrint(Serviceurls.RT_TAT_REPORT + `?from_date=${filterData?.fromDate}&to_date=${filterData?.toDate}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
    }

    const renderFilterScreen = () => {
        return (
            <Box className='eMed_rts_filter_container' >
                <Box className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>Filter</Typography>
                    <Tooltip>
                        <Button onClick={() => { setFilterOpen(false) }}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
                        </Button>
                    </Tooltip>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filterData.fromDate}
                            ToDate={filterData.toDate}
                            DateIndex={filterData.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                </Box>
                <Box>
                    <Stack spacing={2} direction="row" justifyContent={'center'}>
                        <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => {
                            setfilterData({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            })
                        }}>Clear</Button>
                        <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
                            getTatDataList()
                            setFilterOpen(false)
                        }}>Search</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }


    const closeFilter = () => {
        setFilterOpen(false);
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                let TextArray = [
                    { label: "From Date", value: formatDate(filterData?.fromDate || "") },
                    { label: "To Date", value: formatDate(filterData?.toDate || "") },
                ]
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
                    </Box>
                )
            }
            TatDataList?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'patient_names', headerName: 'Patient Details', flex: 0.15,
                    renderCell: (params) => (<Box component={'div'}>{<CommonPatientDetails data={params?.row} />}</Box>
                    ), valueGetter: (params) => {
                        const name = params.row?.patient_names || "";
                        const mobile = params.row?.mobile_number || "";
                        const UHID = params.row?.patient_uhid || "";
                        return `${name} ${mobile} ${UHID}`;
                    }
                },
                {
                    field: 'therapy_name', headerName: 'Therapy', flex: 0.07,
                    renderCell: (params) => (params.row.therapy_name ? params.row.therapy_name?.length > 12 ?
                        <Tooltip placement="top" title={params.row.therapy_name}><Typography fontSize={'0.9vw'}>{params.row.therapy_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.therapy_name || '-'}</Typography> : '-')
                },
                {
                    field: 'session_date', headerName: 'Session Date', flex: 0.07,
                    renderCell: (params) => (params.row.session_date ? formatDate(params.row.session_date) : '-')

                },
                {
                    field: 'arrived_time_str', headerName: 'Arrived Time', flex: 0.07,
                    renderCell: (params) => (params.row.arrived_time_str ? params.row.arrived_time_str : '-')

                },
                {
                    field: 'scheduled_time_str', headerName: 'Schedule Time', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.scheduled_time_str || '-'}</Box>)
                },
                {
                    field: 'start_time_str', headerName: 'Session Start Time', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.start_time_str || '-'}</Box>)

                },
                {
                    field: 'completed_time_str', headerName: 'Session End Time', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.completed_time_str || '-'}</Box>)

                },
                {
                    field: 'tat_time_str', headerName: 'TAT', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.tat_time_str || '-'}</Box>)

                },
            ];
            return (
                <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={TatDataList}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    const msgClose = () => {
        seterrorMsg(false)
        seterrorMsgText("")
        setsuccessMsg(false)
        setsuccessMsgText("")
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
                    {AmountsCard('Avg TAT', avgTAt, true)}
                    {AmountsCard('Total Session Count', sessionCount, true)}
                </Box>
                <Box>
                    <IconButton onClick={() => { setFilterOpen(true) }}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                    </IconButton>
                    <IconButton onClick={getTatDataListPrint}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
                    </IconButton>
                    {/* <IconButton>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
                    </IconButton> */}
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
}

export default RtSessionTatReport